export const overlayConfigs = [
  {
    name: 'Layer 1',
    src: '/overlays/layer-1.png',
    screen: { x: -3, y: 283, width: 606, height: 513 },
    corners: {
      tl: { x: -3, y: 283 },
      tr: { x: 603, y: 341 },
      bl: { x: -1, y: 796 },
      br: { x: 590, y: 765 }
    }
  },
  {
    name: 'Layer 2',
    src: '/overlays/layer-2.png',
    screen: { x: -92, y: 148, width: 746, height: 548 },
    corners: {
      tl: { x: -92, y: 297 },
      tr: { x: 566, y: 148 },
      bl: { x: 22, y: 696 },
      br: { x: 654, y: 614 }
    }
  },
  {
    name: 'Layer 3',
    src: '/overlays/layer-3.png',
    screen: { x: 108, y: 283, width: 541, height: 343 },
    corners: {
      tl: { x: 108, y: 283 },
      tr: { x: 649, y: 310 },
      bl: { x: 116, y: 626 },
      br: { x: 645, y: 594 }
    }
  },
  {
    name: 'Layer 4',
    src: '/overlays/layer-4.png',
    screen: { x: 78, y: 228, width: 598, height: 439 },
    corners: {
      tl: { x: 78, y: 228 },
      tr: { x: 668, y: 267 },
      bl: { x: 91, y: 667 },
      br: { x: 676, y: 608 }
    }
  },
  {
    name: 'Layer 5',
    src: '/overlays/layer-5.png',
    screen: { x: 28, y: 162, width: 533, height: 354 },
    corners: {
      tl: { x: 28, y: 162 },
      tr: { x: 561, y: 162 },
      bl: { x: 33, y: 514 },
      br: { x: 561, y: 516 }
    }
  },
  {
    name: 'Layer 6',
    src: '/overlays/layer-6.jpg',
    screen: { x: 51, y: 398, width: 849, height: 627 },
    corners: {
      tl: { x: 65, y: 398 },
      tr: { x: 897, y: 436 },
      bl: { x: 51, y: 872 },
      br: { x: 850, y: 1025 }
    }
  },
  {
    name: 'Layer 7',
    src: '/overlays/layer-7.jpg',
    screen: { x: 238, y: 358, width: 618, height: 456 },
    corners: {
      tl: { x: 238, y: 359 },
      tr: { x: 856, y: 358 },
      bl: { x: 264, y: 814 },
      br: { x: 856, y: 753 }
    }
  },
  {
    name: 'Layer 8',
    src: '/overlays/layer-8.jpg',
    screen: { x: -85, y: 212, width: 1015, height: 632 },
    corners: {
      tl: { x: -85, y: 281 },
      tr: { x: 930, y: 212 },
      bl: { x: -64, y: 821 },
      br: { x: 840, y: 844 }
    }
  },
  {
    name: 'Layer 9',
    src: '/overlays/layer-9.jpg',
    screen: { x: 127, y: 265, width: 543, height: 465 },
    corners: {
      tl: { x: 127, y: 326 },
      tr: { x: 614, y: 265 },
      bl: { x: 172, y: 730 },
      br: { x: 670, y: 666 }
    }
  },
  {
    name: 'Layer 10',
    src: '/overlays/layer-10.jpg',
    screen: { x: -56, y: 297, width: 928, height: 678 },
    corners: {
      tl: { x: -49, y: 297 },
      tr: { x: 872, y: 408 },
      bl: { x: -56, y: 824 },
      br: { x: 800, y: 975 }
    }
  },
  {
    name: 'Layer 11',
    src: '/overlays/layer-11.jpg',
    screen: { x: 131, y: 110, width: 844, height: 539 },
    corners: {
      tl: { x: 132, y: 110 },
      tr: { x: 966, y: 144 },
      bl: { x: 131, y: 649 },
      br: { x: 975, y: 647 }
    }
  },
  {
    name: 'Layer 12',
    src: '/overlays/layer-12.jpg',
    screen: { x: 52, y: 393, width: 517, height: 349 },
    corners: {
      tl: { x: 52, y: 393 },
      tr: { x: 569, y: 393 },
      bl: { x: 52, y: 742 },
      br: { x: 569, y: 742 }
    }
  },
  {
    name: 'Layer 13',
    src: '/overlays/layer-13.jpg',
    screen: { x: -10, y: 42, width: 702, height: 538 },
    corners: {
      tl: { x: -10, y: 77 },
      tr: { x: 692, y: 42 },
      bl: { x: -2, y: 533 },
      br: { x: 686, y: 580 }
    }
  },
  {
    name: 'Layer 14',
    src: '/overlays/layer-14.jpg',
    screen: { x: -15, y: 89, width: 640, height: 448 },
    corners: {
      tl: { x: -15, y: 89 },
      tr: { x: 625, y: 90 },
      bl: { x: 21, y: 537 },
      br: { x: 615, y: 463 }
    }
  }
]
